import {RaEvent, RaEventType} from "./RaEvent";

export enum MICROPHONECHECK_STATUS {
    manual = 0,
    automatic = 1,
    connect = 2,
    disconnect = 3,
    success = 4,
    cancel = 5,
    reset = 6,
    ios = 7
}

export class MicrophoneCheckEvent extends RaEvent {

    static TYPE:RaEventType = "microphonecheck_event";

    constructor(private _status:MICROPHONECHECK_STATUS) {
        super(MicrophoneCheckEvent.TYPE);
    }

    public get status():MICROPHONECHECK_STATUS {
        return this._status;
    }
}
